<template>
  <div>
    <div class="row">
      <div class="flex lg6 md6 md6">
        <sp-360-panel class="chart-widget" :title="$t('resumo.prazoConcluidas')" :tooltipOptions="tooltipPrazoConcluidas"
          :footerText="$t('rodape.fonteData', {fonte: 'resumo.fonte', data: rodapeData(-1)})" :footerComplementar="$t('resumo.prazoConcluidasRodape')">
          <sp360-chart v-bind:data="prazoPieChartData" :options="separadorMilharOption" type="pie" />
        </sp-360-panel>
      </div>

      <div class="flex lg6 md6">
        <sp-360-panel class="chart-widget" :title="$t('resumo.statusConcluidas')" :tooltipOptions="tooltipStatusConcluidas"
          :footerText="$t('rodape.fonteData', {fonte: 'resumo.fonte', data: rodapeData(-1)})" :footerComplementar="$t('resumo.statusConcluidasRodape')">
          <sp360-chart v-bind:data="concluidasPieChartData" :options="separadorMilharOption" type="pie" />
        </sp-360-panel>
      </div>

    </div>
    <div class="row">
      <div class="flex lg12 md12 ">
        <sp-360-panel class="chart-widget" :title="$t('resumo.topSolicitados')" :tooltipOptions="tooltipServicosMaisSolicitados"
        :footerText="$t('rodape.fonteData', {fonte: 'resumo.fonte', data: rodapeData(-1)})" :footerComplementar="$t('resumo.topSolicitadosRodape')">
            <sp360-chart v-bind:data="solicitadosData" :options="optionsSolicitadosHB" type="horizontal-bar" />
        </sp-360-panel>
      </div>
      <div class="flex lg12 md12 ">
        <sp-360-panel class="chart-widget" :title="$t('resumo.topConcluidos')" :tooltipOptions="tooltipServicosMaisConcluidos"
        :footerText="$t('rodape.fonteData', {fonte: 'resumo.fonte', data: rodapeData(-1)})" :footerComplementar="$t('resumo.topConcluidosRodape')">
            <sp360-chart v-bind:data="concluidosData" :options="optionsConcluidosHB" type="horizontal-bar" />
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'resumo-mensal',
  components: {
    Sp360Chart, Sp360Panel,
  },
  data: function () {
    return {
      separadorMilharOption: {
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            // formatarNumero(numero, casasDecimais=2, prefixo='', posfixo='', separadorMilhar=true)
            formatter: (value) => MethGlob.formatarNumero((parseInt(value) / this.ultimoMes.finalizadas) * 100),
            clamp: false,
            anchor: 'center',
            font: {
              size: 18,
              weight: 'bold',
            },
          },
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
        },
      },
      tooltipPrazoConcluidas: {},
      tooltipStatusConcluidas: {},
      tooltipServicosMaisConcluidos: {},
      tooltipServicosMaisSolicitados: {},
      concluidasPieChartData: {},
      prazoPieChartData: {},
      concluidosData: {},
      solicitadosData: {},
      ultimoMes: {},
      optionsSolicitadosHB: {
        plugins: {
          datalabels: {
            font: {
              size: 14,
              weight: 'bold',
            },
            color: CorUtils.getCorPorNomeSp360('branco'),
            formatter: (value) => MethGlob.thousandSeparator(value),
            clamp: true,
            anchor: 'center',
          },
        },
        tooltips: {
          enabled: false,
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: false,
              callback: (value) => MethGlob.thousandSeparator(value),
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('atendimento.resumoMesServicosMaisSolicitadosEixoX'),
            },
          }],
        },
      },
      optionsConcluidosHB: {
        plugins: {
          datalabels: {
            font: {
              size: 14,
              weight: 'bold',
            },
            color: CorUtils.getCorPorNomeSp360('branco'),
            formatter: (value) => MethGlob.thousandSeparator(value),
            clamp: true,
            anchor: 'center',
          },
        },
        tooltips: {
          enabled: false,
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: false,
              callback: (value) => MethGlob.thousandSeparator(value),
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('atendimento.resumoMesServicosMaisConcluidosEixoX'),
            },
          }],
        },
      },
    }
  },
  computed: {
  },
  created () {
    Promise.all([
      this.$store.dispatch('servicos156/buscarSolicitacoesConsolidado'),
      this.$store.dispatch('servicos156/buscarTopServicosConsolidados', { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),
      this.$store.dispatch('servicos156/buscarTopServicosConsolidados', { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST, intervalo: 'ULTIMO_MES', ordenacao: 'finalizadas' }),
    ])
      .then(
        (respostas) => {
          this.ultimoMes = respostas[0].data.data[0]
          this.recebidas = respostas[1].data.data
          this.finalizadas = respostas[2].data.data
          this.populateConcluidasPieChart()
          this.populatePrazoPieChart()
          this.populateSolicitadosChart()
          this.populateConcluidosChart()
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
    this.tooltipPrazoConcluidas = { content: this.$t('atendimento.resumoMesPrazoConcluidasTooltip'), placement: 'bottom' }
    this.tooltipStatusConcluidas = { content: this.$t('atendimento.resumoMesStatusConcluidasTooltip'), placement: 'bottom' }
    this.tooltipServicosMaisConcluidos = { content: this.$t('atendimento.resumoMesServicosMaisConcluidosTooltip'), placement: 'bottom' }
    this.tooltipServicosMaisSolicitados = { content: this.$t('atendimento.resumoMesServicosMaisSolicitadosTooltip'), placement: 'bottom' }
  },
  methods: {
    rodapeData (d, data) {
      return MethGlob.rodapeData(d, data)
    },
    populateSolicitadosChart () {
      this.solicitadosData = {}
      this.solicitadosData.labels = []
      this.solicitadosData.datasets = []
      let dataset = {
        backgroundColor: [],
        data: [],
      }
      this.recebidas.forEach(servico => {
        this.solicitadosData.labels.push(servico.servico_desc)
        dataset.backgroundColor.push(CorUtils.getCorPorNomeSp360('verde-medio'))
        dataset.data.push(servico.recebidas)
      })
      this.solicitadosData.datasets.push(dataset)
    },
    populateConcluidosChart () {
      this.concluidosData = {}
      this.concluidosData.labels = []
      this.concluidosData.datasets = []
      let dataset = {
        backgroundColor: [],
        data: [],
      }
      this.finalizadas.forEach(servico => {
        this.concluidosData.labels.push(servico.servico_desc)
        dataset.backgroundColor.push(CorUtils.getCorPorNomeSp360('azul-glauco-medio'))
        dataset.data.push(servico.finalizadas)
      })
      this.concluidosData.datasets.push(dataset)
    },
    populateConcluidasPieChart () {
      this.concluidasPieChartData = {}
      this.concluidasPieChartData.labels = [this.$t('resumo.labelFinalizadas'), this.$t('resumo.labelIndeferidas')]
      this.concluidasPieChartData.datasets = []
      let dataset = {
        backgroundColor: ['#FFCC22', '#33AADD'],
        data: [this.ultimoMes.deferidas, this.ultimoMes.indeferidas],
      }
      this.concluidasPieChartData.datasets.push(dataset)
    },
    populatePrazoPieChart () {
      this.prazoPieChartData = {}
      this.prazoPieChartData.labels = [this.$t('resumo.labelForaPrazo'), this.$t('resumo.labelDentroPrazo')]
      this.prazoPieChartData.datasets = []
      let dataset = {
        backgroundColor: ['#FFCC22', '#33AADD'],
        data: [this.ultimoMes.finalizadas_fora_prazo, this.ultimoMes.finalizadas_dentro_prazo],
      }
      this.prazoPieChartData.datasets.push(dataset)
    },
  },
}
</script>

<style lang='scss' scoped>
.va-chart {
  max-height: 25rem
}
</style>
